import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getVoting, submitSurvey } from '../../redux/data/dataActions';
import { setPhoneNumber, setTermsAndConditions, setSurveyNoTextError, setSurveyUserSelection, setSurveySubmissionError, setSurveySubmissionSuccess } from '../../redux/data/dataSlice';
import "../../assets/css/voting.css";
import DeniedIcon from "../../assets/images/denied.svg";
import SuccessIcon from "../../assets/images/success.svg";
import InfoIcon from "../../assets/images/info.svg";
import CloseImage from "../../assets/images/close.svg";
import config from "../../config/memberhubContents.json";
import SurveyQuestions from "./surveyQuestions";
import SurveyFooter from "./surveyFooter";

function SurveyModal(props) {
    const dispatch = useDispatch();
    const isMobileView = useSelector(state => state.data.isMobileView);
    const userSelections = useSelector(state => state.data.surveyUserSelections);
    const surveyCompleted = useSelector(state => state.data.surveySubmissionSuccess);
    const surveySubmissionError = useSelector(state => state.data.surveySubmissionError);
    const surveySubmissionNoTextError = useSelector(state => state.data.surveySubmissionNoTextError);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [surveyError, setSurveyError] = useState("");
    const survey = props && props.survey;
    const surveyTaken = survey && survey.response && survey.results;
    const questions = survey && survey.questions;
    const singleQuestion = survey && survey.questions && survey.questions.length === 1;
    const rectangularImgs = survey && survey.extra_data && survey.extra_data.image_size && survey.extra_data.image_size === "1";
    const skipEnabled = questions && questions[currentQuestionIndex] && questions[currentQuestionIndex].required === false;
    const styles = `modal-body modal-survey-body${singleQuestion ? ' no-progress-bar' :
        ''}${surveyCompleted ? ' no-results' : ''}`;

    const submitUserSelections = () => {
        setSurveyError(null);
        dispatch(setSurveyNoTextError(null));
        dispatch(setSurveySubmissionError(null));

        const checkPassed = checkUserSelections();

        if (checkPassed) {
            let paddedSelections = { ...userSelections };
            questions.forEach((q, i) => {
                if (!paddedSelections[i]) {
                    paddedSelections[i] = {
                        question_id: q.id,
                        selected_answers: []
                    };
                }
            });
            const payload = {
                activity_id: props.survey.id.toString(),
                survey_response: paddedSelections,
            };
            dispatch(submitSurvey(payload));
            scrollView();
        }
    };

    const skipQuestion = () => {
        scrollView();
        setSurveyError(null);
        setCurrentQuestionIndex(currentQuestionIndex + 1);
    };

    const nextQuestion = () => {
        if (!enabled) {
            showQuestionError(currentQuestionIndex);
            return;
        }
        scrollView();
        setSurveyError(null);
        setCurrentQuestionIndex(currentQuestionIndex + 1);
    };

    const prevQuestion = () => {
        document.querySelector('.modal-body').click();
        document.querySelector('.modal-button-cta').blur();
        // ^ simulates click to reset Next button state on iPhone
        scrollView();
        setSurveyError(null);
        dispatch(setSurveyNoTextError(false));
        setCurrentQuestionIndex(currentQuestionIndex - 1);
    }

    const scrollView = () => {
        const body = document.querySelector('.modal-body');
        body.scrollTo(0, 0);
    };

    const showQuestionError = (questionIndex) => {
        let currentQ = questions[questionIndex];

        if (currentQ.question_type === 'text') {
            let text = document.getElementById(`question_${questionIndex}_textarea`).value;
            if (!text || text === "") {
                dispatch(setSurveyNoTextError(true));
                return;
            }
        }

        if (currentQ.question_type === 'select_multiple') {
            if (currentQ.allow_other) {
                let otherCheckBoxSelected = document.getElementById(`question_${questionIndex}option_other`).checked;
                if (otherCheckBoxSelected) {
                    let otherText = userSelections[questionIndex] && userSelections[questionIndex].other;
                    if (!otherText) {
                        dispatch(setSurveyNoTextError(true));
                        return;
                    }
                }
            }
            setSurveyError(config.quizSubmissionErrorNoSelection);
            return;
        }

        setSurveyError(config.quizSubmissionErrorNoSelection);
        return;
    };

    const checkQuestionAnswered = (question, i) => {
        let answered;
        if (i >= questions.length) {
            return true;
        }

        switch (question.question_type) {
            case 'select_multiple':
                if (question.allow_other) {
                    let other = document.getElementById(`question_${i}option_other`);
                    if (other && other.checked) {
                        answered = userSelections[i] && userSelections[i].selected_answers && userSelections[i].other;
                    } else {
                        answered = userSelections[i] && userSelections[i].selected_answers && userSelections[i].selected_answers.length > 0;
                    }
                } else {
                    answered = userSelections[i] && userSelections[i].selected_answers && userSelections[i].selected_answers.length > 0;
                }
                break;

            case 'text':
                answered = userSelections[i] && userSelections[i].text_answer;
                break;

            case 'select_one':
            default:
                answered = userSelections[i] && userSelections[i].selected_answers && userSelections[i].selected_answers.length > 0;
                break;
        }
        return answered;
    };

    const checkUserSelections = () => {
        if (userSelections === []) return false;

        let unanswered = 0;

        questions.forEach((q, i) => {
            if (q.required) {
                let answered = checkQuestionAnswered(q, i);
                if (!answered) {
                    showQuestionError(i);
                    unanswered++;
                }
            }
        });

        return unanswered === 0;
    };

    const enabled = skipEnabled || checkQuestionAnswered(questions[currentQuestionIndex], currentQuestionIndex);

    return (
        <>
            <div className="modal-header">
                <Link
                    to={{ pathname: "/voting", search: window.location.search }}
                    className="modal-close"
                    data-track="click"
                    data-id="nba:membership-hub:dismiss"
                    data-section="voting"
                    data-type="dismiss"
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getVoting());
                        dispatch(setPhoneNumber(""));
                        dispatch(setTermsAndConditions(false));
                        dispatch(setSurveyUserSelection([]));
                        dispatch(setSurveySubmissionSuccess(false));
                        dispatch(setSurveyNoTextError(false));
                        dispatch(setSurveySubmissionError(null));
                        setSurveyError("");
                    }}>
                    <img alt="close" src={CloseImage} />
                </Link>
            </div>
            <div className="modal-header-title">
                {survey.title}
            </div>
            <div className="modal-header-subtitle" dangerouslySetInnerHTML={{ __html: survey.description }}></div>
            <div className="modal-header-separator"></div>
            {(surveyCompleted || surveyTaken) &&
                <div className={`modal-success ${surveyCompleted ? 'completed' : ''}`} style={{ marginBottom: 0 }}>
                    <img src={SuccessIcon} alt="Success" style={{ width: '20px', height: '20px' }} />
                    {config.surveySubmissionSuccess}
                </div>
            }
            {surveySubmissionError && !surveySubmissionNoTextError &&
                <div className="modal-error">
                    <img src={DeniedIcon} alt="Error" style={{ width: '20px', height: '20px' }} />
                    {surveySubmissionError}
                </div>
            }
            {surveyError &&
                <div className="modal-error">
                    <img src={DeniedIcon} alt="Error" style={{ width: '20px', height: '20px' }} />
                    {surveyError}
                </div>
            }
            {currentQuestionIndex === questions.length && !surveyCompleted && !surveyError && !surveySubmissionError &&
                <div className="modal-review">
                    <img src={InfoIcon} alt="Info" style={{ width: '20px', height: '20px' }} />
                    <div className="review-text">
                        <span className="review-header" >{config.surveyReviewHeaderText}</span>
                        <span className="review-body">{config.surveyReviewBodyText}</span>
                    </div>
                </div>
            }
            <div className={styles}>
                {(surveyCompleted || surveyTaken) ?
                    <div style={{ minHeight: '300px' }}></div>
                    :
                    <SurveyQuestions questions={questions} current={currentQuestionIndex} setSurveyError={setSurveyError}
                        surveyError={surveyError} rectangularImgs={rectangularImgs} isMobileView={isMobileView} />
                }
            </div>
            <SurveyFooter questions={questions} current={currentQuestionIndex} disabled={!enabled} skip={skipQuestion}
                next={nextQuestion} back={prevQuestion} submit={submitUserSelections} surveyTaken={surveyTaken} />
        </>
    );
}

export default SurveyModal;
